<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0 mt-4">
      <div class="container-box center" > 
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <div class="search-input-container">
    <CInput
      type="text"
      placeholder="Search Tutor Name"
      v-model.lazy="SearchQuery"
      @change="ApplyFilter"
      class="p-2"
    />
    <span v-if="SearchQuery" class="close-button" @click="ClearSearch">&times;</span>
  </div>
            <div style="display: flex" class="mb-5 d-sm-down-none">
              <CCol sm="12" class="mt-2 mb-3">
              
                <CRow>
                  <CCol v-for="rate in FilteredRate" :key="rate.id" sm="4">

                    <CCard class="custom-card-advertise mb-5" style=" height: 158px;" @click="GoToFTTutorProfile(rate.userId)">
                      <div v-if="rate.profileImage == null">
                        <img
                          src="../../assets/img/icon/icondefault.svg"
                          class="custom-bg-advetise"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      <div v-else>
                        <img
                          :src="rate.profileImage"
                          class="custom-bg-advetise"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      
                      <div class="bg-linear">
                        <h1 class="custom-text-adv ml-2"> {{ rate.teacherName}} </h1>
                        <span v-if="rate.achivementContent != 'No achivement'">
                          <label class="custom-label-text ml-2">
                            {{ rate.achivementContent }}
                          </label>
                        </span>
                        <span v-else>
                          <label class="custom-label-text ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px;...">
                            {{ rate.aboutTutor }}
                          </label>
                        </span>
                        
                        <br />
                        <img src="../../assets/img/icon/iconstar.svg" class="ml-2" />
                        <label class="float-right custom-label-text mr-2 mt-1"> 
                          {{ rate.totalRating }} ratings
                        </label>
                      </div>
                    </CCard>
                  </CCol>
                </CRow>
              </CCol>
            </div>

            <div style="display: flex" class="mb-5 d-sm-flex d-md-none">
              <CCol sm="12" class="mt-2 mb-3">
                <CRow>
                  <CCol v-for="rate in FilteredRate" :key="rate.id" col="6">

                    <CCard class="custom-card-advertise mb-3" style="margin-left:0px; height: 158px;" @click="GoToFTTutorProfile(rate.userId)">
                      <div v-if="rate.profileImage == null">
                        <img
                          src="../../assets/img/icon/icondefault.svg"
                          class="custom-bg-advetise"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      <div v-else>
                        <img
                          :src="rate.profileImage"
                          class="custom-bg-advetise"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      
                      <div class="bg-linear">
                        <h1 class="custom-text-adv ml-2">  {{ rate.teacherName}} </h1>
                        <span v-if="rate.achivementContent != 'No achivement'">
                          <label class="custom-label-text ml-2">
                            {{ rate.achivementContent }}
                          </label>
                        </span>
                        <span v-else>
                          <label class="custom-label-text ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px;...">
                            {{ rate.aboutTutor }}
                          </label>
                        </span>
                        
                        <br />
                        <img src="../../assets/img/icon/iconstar.svg" class="ml-2" />
                        <label class="float-right custom-label-text mr-2 mt-1"> 
                          {{ rate.totalRating }} ratings
                        </label>
                      </div>
                    </CCard>
                  </CCol>
                </CRow>
              </CCol>
            </div>


          </div>
        </div>
      </div>
    </CContainer>

    <div class="header-top">Tutor of The Month</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";


export default {
  components: {
   
  },
  data: function () {
    return {
      user: {},
      rating: [],
      SearchQuery: "",
      FilteredRate: [],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetTutorRating();
            
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.rating, ["teacherName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(
          arr,
          ({ teacherName }) =>
            _.some([
              _.includes(!teacherName || teacherName.toLowerCase(), [
                this.SearchQuery.toLowerCase(),
              ]),
            
            ])
        );
        this.FilteredRate = result;
      }
    },

    // GetAuthorizeProfile() {
    // this.$API
    //   .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
    //     withCredentials: true,
    //   })
    //   .then((response) => {
    //     if (response.status == 200 && response.data != null) {
    //       this.studentProfileAuthorize = response.data;
    //       this.photoURL =
    //         "https://pickiddo.com" + this.studentProfileAuthorize;
    //     }
    //   });
    // },

    // GetSubject() {
    //   this.$API
    //     .get(this.$SubjectListAuthorize, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.subject = response.data;
    //         this.FilterSubject = this.subject;
    //       }
    //     });
    // },

    GetTutorRating() {
      if(this.user.countryId > 0 && this.user.countryId != 13)
      {
        this.$API
        .get(this.$GetTutorRatingByCountryId + "?countryId=" + this.user.countryId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rating = response.data;
          }
        });
      }
      else
      {
        this.$API
        .get(this.$GetTutorRating, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rating = response.data;
            this.FilteredRate = this.rating;
          }
        });

      }
     
    },

    GoToFTTutorProfile(teacherId) {
      this.$router.push("/FindTutor/FTTutorProfile?teacherId=" + teacherId);
    },

    GoBack() {
      this.$router.back();
    },

    // GetTutorRatingHeader() {
    //   this.$API
    //     .get(this.$GetTutorRatingheader, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.ratinghead = response.data;
    //       }
    //     });
    // },

    // GetListChild() {
    //   this.$API
    //     .get(this.$ListChild + "?userID=" + this.user.id, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.childs = response.data;
    //       }
    //     });
    // },

    // GoToClassType() {
    //   this.$router.push("/FindTutor/FTClassType");
    // },

    // GoToMyTutor() {
    //   this.$router.push("/FindTutor/MyTutor");
    // },

    // GoToAllToTM() {
    //   this.$router.push("/FindTutor/AllTutorOfTheMonth");
    // },

    // GoToBecomeTutor() {
    //   this.$router.push("/FindTutor/BecomeATutor");
    // },
    
    // GoBack() {
    //   this.$router.back();
    // },

    // GoToFTTutorProfile(teaId) {
    //   this.$router.push(
    //     "/FindTutor/FTTutorProfile?teacherId=" +
    //     teaId
    //   );
    // },

    // ApplyFilter: function () {
    //   var arr = _.orderBy(this.subject, ["subjectName"], ["asc"]);
    //   if (_.isEmpty(arr) == false) {
    //     const result = _.filter(arr, ({ subjectName }) =>
    //       _.some([
    //         _.includes(!subjectName || subjectName.toLowerCase(), [
    //           this.SearchQuery.toLowerCase(),
    //         ]),
    //       ])
    //     );
    //     this.FilterSubject = result;
    //   }
    // },
    ClearSearch() {
      this.SearchQuery = "";
      // Optionally, you can also trigger ApplyFilter() here to clear the filter
      this.ApplyFilter();
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}

.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}

.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}

body {
  font-family: "Montserrat", sans-serif;
}

.class-top-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;  
  gap: 8px;

  position: absolute;
  /* width: 135px;   */
  left: 0px;    
}

.top-header-badge {
  padding: 10px;
  top:20px;
  height: 23px;

  /* Pure/White */

  background: #FFFFFF;
  border-radius: 4px;

  /* width: 96px;
  height: 15px; */

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */


  /* Blue/Primary */

  color: #007CEF;


  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.class-teacher-name {
  padding: 4px 1px;
  top: 50px;
  /* height: 40px; */

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #FFFFFF;


  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}

.class-teach-subject {
  /* padding: 4px 1px; */
  top: 80px;
  height: 15px;
  width: auto;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */


  /* Pure/White */

  color: #FFFFFF;


  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}

.carousel {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  position: absolute;
  width: 36px;
  height: 6px;
  left: 20px;
  top: 115px;
}

.circle {
  vertical-align: top;
  position: absolute;
  top: 20px;
  text-align: right;
  float: none;
  left: 20px;
}

.custom-bg-icon {
  vertical-align: top;
  position: absolute;
  top: 10px;
  text-align: center;
  margin: 20px auto;
  float: none;
  left: 0;
  right: 0;
}

.Asv1 {
position: absolute;
width: 107px;
height: 107px;
left: 249px;
/* top: 62px; */

border-radius: 107px;
}

.class-card-box {
/* White Solid AF */

background: #FFFFFF;

  box-shadow: -5px 8px 20px -1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  /* margin: 0px 20px; */
  display: flex;
  /* flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 16px; */
  width:50%; 
  height: 117px;

}

.card-blue {
  /* width: 335px; */
height: 84px;

/* Brand/Gradient-Blue */

background: linear-gradient(286.01deg, #5BC4FF 7.93%, #0085FF 96.74%);
border-radius: 10px;
margin: 0px 20px;
display: flex;
justify-content: center;

/* Inside auto layout */

/* flex: none;
order: 0;
flex-grow: 0; */
}

.label-blue {
  position: absolute;
width: 205px;
height: 44px;
left: 16px;
top: 20px;

/* Title/1/Semibold */

font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 22px;

/* Pure/White */

color: #FFFFFF;;

}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #FFFFFF;


  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}

.class-card-multiple {
 display: flex;
flex-direction: row;
justify-content: center;
align-items: flex-start;
padding: 0px;
gap: 16px;

/* width: 334px; */
height: 117px;
margin: 0px 20px;
display: flex;


/* Inside auto layout */

flex: none;
order: 1;
flex-grow: 0;
}
.custom-frame-text{
  /* Frame 8382 */


/* Auto layout */

display: flex;
flex-direction: row;
justify-content: normal;
align-items: center;
padding: 17px;
gap: 134px;

width: 335px;
height: 20px;


/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
}

.carousel {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    padding: 0px;
    gap: 4px;
    position: absolute;
    width: 100%;
    height: 6px;
    left: 0px; 
    top: 30px;
}


.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: left;  
    margin-right: 15%;
    margin-left: 5%;  
    list-style: none; 
    margin-bottom: -20px;  
}

.carousel-indicators li {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: 5px;  
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    -webkit-transition: opacity 0.6s ease;
    transition: opacity 0.6s ease;
}



.carousel-inner {
  position: relative;
  width: 100%;
  overflow: visible;
  top: -30px;
  @include clearfix();
}
.search-input-container {
  position: relative;
}

.close-button {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999; /* Adjust the color as needed */
  font-size: 1.2em;
}
</style>